<template>
  <v-container class="pa-0">
    <!-- Header/Search Area -->
    <v-row class="mb-6 align-center">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          label="Buscar industria..."
          prepend-inner-icon="fas fa-search"
          outlined
          dense
          hide-details
          clearable
          :disabled="loading"
          class="modern-search-field"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn color="primary" depressed @click="update(-1)" class="px-6">
          <v-icon left small>fas fa-plus</v-icon>
          Nueva Industria
        </v-btn>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        sort-by="name"
        class="modern-table"
        :items-per-page="15"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 15, 30, 50]
        }"
      >
        <template v-slot:item.id="{ item }">
          <span class="caption grey--text font-weight-bold">#{{ item.id }}</span>
        </template>

        <template v-slot:item.name="{ item }">
          <span class="body-2 font-weight-medium">{{ item.name }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="primary" @click.stop="update(item.id)">
            <v-icon small>fas fa-edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-results>
          <div class="pa-8 text-center grey--text">
            <v-icon large class="mb-2 opacity-30">fas fa-search-minus</v-icon>
            <div>No se encontraron industrias que coincidan con la búsqueda.</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal -->
    <v-dialog v-model="showDialog" max-width="500" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <industry-create-update  
          :id="item"
          @updated="fetch"
          @close="showDialog=false"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { fetchIndustries } from '@/api/customers'
import notifications from '@/utils/notifications'
import IndustryCreateUpdate from '@/components/customers/IndustryCreateUpdate.vue'

export default {
  name: 'Industries',
  components: { IndustryCreateUpdate },
  data() {
    return {
      loading: false,
      item: '',
      items: [],
      search: '',
      showDialog: false,
      headers: [
        { text: 'ID', value: 'id', align: 'start', width: '100' },
        { text: 'Nombre de la Industria', value: 'name', align: 'start' },
        { text: 'Acciones', value: 'actions', align: 'center', width: '100', sortable: false }
      ],
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await fetchIndustries()
        this.items = res
      } catch (err) {
        notifications.showError('Error cargando industrias: ' + err)
      } finally {
        this.loading = false
      }
    },
    update(item) {
      this.item = item
      this.showDialog = true
    }
  },
  async mounted() {
    this.fetch()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
}
.opacity-30 { opacity: 0.3; }
</style>